module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"FooterContact":{"email":{"label":"E-mail:"},"phone":{"label":"Telefon:"},"title":"Kontakt"}},"de":{"FooterContact":{"title":"Kontakt"}},"sk":{"FooterContact":{"title":"Kontakt"}}}')
  delete Component.options._Ctor
}
